type AuthStatusMessageProps = {
  tone: "error" | "success" | "info";
  message: string;
};

export function AuthStatusMessage({ tone, message }: AuthStatusMessageProps) {
  return (
    <div className={`auth-status auth-status--${tone}`} data-oid="1nzudo9">
      {message}
    </div>
  );
}
